<template>

  <v-row v-if="watchlists">
    <v-col v-if="$vuetify.breakpoint.mdAndUp || watchlists.length === 0"
           :cols="watchlists.length > 0 && $vuetify.breakpoint.mdAndUp ? 4 : watchlists.length === 0 && $vuetify.breakpoint.mdAndUp ? 8 : 12">
      <fin-new-watchlist :no-watchlist="watchlists.length === 0"
                         :new-watch-list-allowed="watchlists.length < maxWatchlists"
                         @showCreateWatchlistDialog="$emit('showCreateWatchlistDialog')"/>
    </v-col>
    <v-col v-if="watchlists.length > 0"
           :cols="$vuetify.breakpoint.mdAndUp ? 8 : 12">
      <fin-scroll-carousel :items="watchlists">
        <template #default="{item}">
          <v-card class="pa-5"
                  style="display: flex; flex-direction: column;"
                  :width="carouselItemWidth"
                  :min-width="carouselItemWidth"
                  :max-width="carouselItemWidth">
            <v-row dense style="height: 100%;">
              <v-col cols="12">
                <p v-style:opacity="item.inactive ? 0.5 : 1" class="watchlist-name mb-1">{{ item.name }}</p>
                <p v-if="item.watched.items.length === 0" v-style:opacity="item.inactive ? 0.5 : 1"
                   class="more-instruments">
                  Deine Watchlist enthält noch keine Wertpapiere
                </p>

                <fin-small-performance-chart
                  v-for="(watchedItem, index) in item.watched.items.slice(0,nbInstPerCard).filter(instr => instr.instrument !== null)"
                  :key="index"
                  :chart-options="getOptions(watchedItem, item.inactive)"
                  :inactive-item="item.inactive"
                  :title="watchedItem.instrument.name"
                  class="wl-item"
                  content-only
                  @click="instrumentClicked(watchedItem.instrument)"/>
              </v-col>

              <v-col align-self="end" class="pb-0 align-end" cols="12">
                <p v-if="item.watched.items.length > nbInstPerCard" class="more-instruments mb-1 justify-start">
                  {{ item.watched.items.length - nbInstPerCard }}
                  <span v-if="item.watched.items.length - nbInstPerCard === 1">weiteres Wertpapier</span>
                  <span v-else>weitere Wertpapiere</span>
                </p>

                <v-card-actions class="justify-center pa-0" style="width: 100%">
                  <div style="width: 100%;">
                    <v-divider :inset="false" class="my-2"/>
                    <div style="text-align: right;">
                      <v-btn :disabled="item.inactive"
                             :to="{ name: 'watchlistDetails', params: { id: item.id }}"
                             class="py-1 mr-3 justify-center" color="white"
                             elevation="0"
                             @click.native="viewWatchlistClicked">
                        <span class="more">Watchlist ansehen</span>
                      </v-btn>

                      <v-icon v-if="hasInactiveWatchlists && !item.inactive"
                              @click="changeWatchlistStatusConfirm(item.id, item.name,true)">
                        mdi-lock-open-variant
                      </v-icon>
                      <v-icon v-else-if="hasInactiveWatchlists && item.inactive"
                              :color="$finColors.accentRed"
                              @click="changeWatchlistStatusConfirm(item.id, item.name,false)">
                        mdi-lock
                      </v-icon>

                      <v-icon class="ml-3" @click="deleteWatchlistConfirm(item.id, item.name)">
                        icon-delete
                      </v-icon>
                    </div>
                  </div>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card>
        </template>
      </fin-scroll-carousel>
    </v-col>
  </v-row>

</template>

<script>
import FinNewWatchlist from "./newWatchlist"
import FinScrollCarousel from "../../../common/ScrollCarousel"
import {mapGetters} from "vuex"
import FinChartBuilder from "@/components/common/Chart2/FinChartBuilder"
import FinSmallPerformanceChart from "@/components/common/Chart2/PerformanceCharts/SmallPerformanceChart"
import {myHubWatchlistInstrumentSubscription} from "@/js/finSubscriptions"
import AmplitudePush from "@/mixins/AmplitudePush"
import {API} from "@/plugins/finAmplifyModules"
import {itemInactiveStatus} from "@/js/finMutations"
import {PRICEMODEL_FEATURE_IDS} from "@/js/finPriceModel"
import {finWatchlistAPI} from "@/js/finAPI"
import PriceModel from "@/mixins/PriceModel"

const {graphqlOperation} = require('@/plugins/finAmplifyModules')

export default {
  name: 'FinMyWatchlists',
  components: {
    FinSmallPerformanceChart,
    FinScrollCarousel,
    FinNewWatchlist
  },
  props: {
    watchlists: {
      type: Array
    }
  },
  data() {
    return {
      size: "small",
      currencyString: '€',
      nbInstPerCard: 3,
      carouselItemWidth: 275,
    }
  },
  mixins: [AmplitudePush, PriceModel],
  computed: {
    ...mapGetters('auth', ['userId', 'profile']),
    hasInactiveWatchlists() {
      return this.watchlists.find(w => w.inactive === true) !== undefined
    },
    maxWatchlists() {
      return this.priceModelEnabledAndLimit(PRICEMODEL_FEATURE_IDS.WATCHLIST.id)
    },
  },
  methods: {
    instrumentClicked(item) {
      this.pushToAmplitude({
        'event': 'fincraft_finhub_watchlists_goto_instrument',
        'step': 'instrument_details',
        'placement': 'finhub_watchlists',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      this.$router.push({name: item.assetClass === 'SHARE' ? 'companyDetail' : 'etfDetail', params: {id: item.id}})
    },
    getOptions(item, inactive) {
      const timeseries = item.instrument?.mainListing?.timeSeries1M
      const timeseriesData = FinChartBuilder.mapTimeSeriesPoint(timeseries)
      let result = FinChartBuilder.createCardSelectorChart(item.instrument.name, timeseriesData, this.size, this.$vuetify.breakpoint, true)
      result.tooltip = {
        valueSuffix: "€",
        pointFormat: '{point.y}'
      }

      // only create subscriptions for active watchlists
      if (!inactive) {
        result.subscriptions = [
          {
            subscription: graphqlOperation(myHubWatchlistInstrumentSubscription, {id: item.instrument.id}),
            trigger({data}, {chart}) {
              const {price: y, timestamp, id} = data.onCreateRealTimePrice
              if (id !== item.instrument.id) {
                //check if this happens and how
                return
              }
              const x = (new Date(timestamp)).getTime()
              if (chart.series?.length) {
                chart.series[0].addPoint([x, y], false, false)
                const {min, max} = chart.xAxis[0].getExtremes()
                chart.xAxis[0].setExtremes(x - (max - min), x, true, true, {trigger: 'addPoint'})
              }
            }
          }
        ]
      }

      return result
    },
    viewWatchlistClicked() {
      this.pushToAmplitude({
        'event': 'fincraft_finhub_watchlists_goto_watchlist',
        'step': 'watchlist_details',
        'placement': 'finhub_watchlists',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
    },
    deleteWatchlistConfirm(wlId, title) {
      this.$confirm({
        title: 'Watchlist löschen',
        text: `Möchtest du "${title}" wirklich löschen?`,
        dialogWidth: 350,
        confirmBtn: 'Ja'
      })
        .then(() => {
          this.deleteWatchlist(wlId)
        }).catch(() => {
      })
    },
    async deleteWatchlist(watchlistId, title) {
      console.log("MyWatchlistsWrapper deleteWatchlist not yet implemented", watchlistId)

      try {
        await finWatchlistAPI.deleteWatchlist({id: watchlistId})

        this.$emit('reloadWatchlists')
      } catch (error) {
        console.error('Error deleting watchlist', error, watchlistId)
        this.$toasted.global.finToast({
          message: `Beim Löschen deiner Watchlist %name% ist ein Fehler aufgetreten. Bitte versuche es später erneut.`,
          placeholders: [{name: "name", content: title}],
          type: 'error'
        })
      }
    },
    changeWatchlistStatusConfirm(wlId, title, newStatus) {
      const text = []
      if (!newStatus) {
        const hint = 'Warum ist diese Watchlist gesperrt?'
        text.push({
          autoParse: false,
          type: "paragraph",
          text: hint,
          spans: [{
            "start": 0,
            "end": hint.length,
            "type": "crossref",
            "data": {"to": this.profile.stripeId ? "watchlistsperre-downgrade" : "watchlistsperre-paywall"}
          }]
        })
      }
      text.push({
        type: "paragraph",
        text: `Möchtest du die Watchlist "${title}" wirklich ` + (newStatus ? 'deaktivieren' : 'aktivieren') + '?',
        spans: [],
      })

      this.$confirm({
        title: 'Watchlist ' + (newStatus ? 'deaktivieren' : 'aktivieren'),
        text,
        dialogWidth: 400,
        confirmBtn: 'Ja',
        textWithLexikonLink: true,
      })
        .then(() => {
          this.changeWatchlistStatus({newStatus, wlId: wlId, title})
        }).catch(() => {
      })
    },
    async changeWatchlistStatus(statusObj) {
      console.log("MyWatchlistWrapper.changeWatchlistStatus", statusObj)

      try {
        await API.graphql(graphqlOperation(itemInactiveStatus, {
          featureId: PRICEMODEL_FEATURE_IDS.WATCHLIST.id,
          itemId: statusObj.wlId,
          newStatus: statusObj.newStatus,
        }))

        this.$emit('reloadWatchlists')
      } catch (error) {
        if (error.errors.length === 1 && error.errors[0].errorType === 'ActiveItemCountExceededException') {
          this.$confirm({
            title: 'Hinweis',
            text: 'Dein Abo erlaubt dir derzeit die Nutzung von ' + this.maxWatchlists + ' Watchlist(s).\n\nUm diese Watchlist aktiv zu nutzen, musst du andere Watchlists deaktivieren oder löschen.',
            dialogWidth: 400,
            textWithLexikonLink: true,
            cancelBtn: null,
          })
        } else {
          console.error('Error de/activating watchlist', error, statusObj)
          this.$toasted.global.finToast({
            message: `Beim ${statusObj.newStatus ? 'Deaktivieren' : 'Aktivieren'} deiner Watchlist %name% ist ein Fehler aufgetreten.`,
            placeholders: [{name: "name", content: statusObj.title}],
            type: 'error'
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.more {
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  text-align: center;
}

.watchlist-name {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}

.more-instruments {
  color: $fin-color-cool-grey;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
}

.wl-item.v-card {
  padding: 24px 0 !important;
}
</style>
